$( function() {
  var downloads = [
    {
      value: "jca111",
      label: "JCA111 - USB-C™ to VGA Adapter",
      id: "#jca111-show",
      desc: "USB-C™ to VGA Adapter"      
    },
    {
      value: "jca140",
      label: "JCA140 - USB™ Type-C to 4K DisplayPort™ Adapter",
      id: "#jca140-show",
      desc: "USB-C™ to 4K DisplayPort™ Adapter"      
    },
    {
      value: "jca141",
      label: "JCA141 - USB-C™ to 4K DisplayPort™ Cable",
      id: "#jca141-show",
      desc: "USB-C™ to 4K DisplayPort™ Cable"      
    },
    {
      value: "jca153",
      label: "JCA153 - USB-C™ to 4K HDMI™ Adapter",
      id: "#jca153-show",
      desc: "USB-C™ to 4K HDMI™ Adapter"      
    },
    {
      value: "jca153g",
      label: "JCA153G - USB-C™ to 4K HDMI™ Adapter",
      id: "#jca153g-show",
      desc: "USB-C™ to 4K HDMI™ Adapter"      
    },
    {
      value: "jca365",
      label: "JCA365 - USB-C® to Dual HDMI™ Multi-Monitor Adapter",
      id: "#jca365-show",
      desc: "USB-C® to Dual HDMI™ Multi-Monitor Adapter"      
    },
    {
      value: "jca366",
      label: "JCA366 - USB-C™ to 4-Port HDMI™ Multi-Monitor Adapter",
      id: "#jca366-show",
      desc: "USB-C™ to 4-Port HDMI™ Multi-Monitor Adapter"      
    },
    {
      value: "jca374",
      label: "JCA374 - USB-C™ Multi-Adapter - HDMI™/Ethernet/USB™ 3.1 HUB/PD 3.0",
      id: "#jca374-show",
      desc: "USB-C™ Multi-Adapter - HDMI™/Ethernet/USB™ 3.1 HUB/PD 3.0"      
    },
    {
      value: "jcd376",
      label: "JCD376 - USB-C™ Multiport Adapter with Power Delivery",
      id: "#jcd376-show",
      desc: "USB-C™ Multiport Adapter with Power Delivery"      
    },
    {
      value: "jca378",
      label: "JCA378 - USB-C™ to VGA & USB™ 3.0 with Power Delivery",
      id: "#jca378-show",
      desc: "USB-C™ to VGA & USB™ 3.0 with Power Delivery"      
    },
    {
      value: "jca379",
      label: "JCA379 - USB-C® to HDMI™ & USB™ 3.0 with Power Delivery",
      id: "#jca379-show",
      desc: "USB™ Type-C to HDMI™ & USB™ 3.0 with Power Delivery"      
    },
    {
      value: "jca379e",
      label: "JCA379EW/ER/EC - Eco-Friendly USB-C® to 4-Port Type-C Gen 2 Hub",
      id: "#jca379e-show",
      desc: "Eco-Friendly USB-C® to 4-Port Type-C Gen 2 Hub"      
    },
    {
      value: "jca465",
      label: "JCA465 - 8K USB-C® to Dual HDMI™ Display Adapter",
      id: "#jca465-show",
      desc: "8K USB-C® to Dual HDMI™ Display Adapter"      
    },
    {
      value: "jcd348",
      label: "JCD348 - USB-C™ ULTRADRIVE MINIDOCK®",
      id: "#jcd348-show",
      desc: "USB-C™ ULTRADRIVE MINIDOCK®"      
    },
    {
      value: "jcd381",
      label: "JCD381 - USB-C™ Dual HDMI™ Mini Dock",
      id: "#jcd381-show",
      desc: "USB-C™ Dual HDMI™ Mini Dock"      
    },
    {
      value: "jcd382",
      label: "JCD382 - USB-C™ ULTRADRIVE MINIDOCK™",
      id: "#jcd382-show",
      desc: "USB-C™ ULTRADRIVE MINIDOCK™"      
    },
    {
      value: "jcd383",
      label: "JCD383 - USB-C™ Multi Adapter (9 Functions in 1)",
      id: "#jcd383-show",
      desc: "USB-C™ Multi Adapter (9 Functions in 1)"      
    },
    {
      value: "jcd384",
      label: "JCD384 - USB-C™ Multi Adapter (10 Functions in 1)",
      id: "#jcd384-show",
      desc: "USB-C™ Multi Adapter (10 Functions in 1)"      
    },
    {
      value: "jcd389",
      label: "JCD389 - ULTRADRIVE Kit USB-C™ Multi-Display Modular Dock",
      id: "#jcd389-show",
      desc: "ULTRADRIVE Kit USB-C™ Multi-Display Modular Dock"      
    },
    {
      value: "jcdp392",
      label: "JCDP392 - 90W Built-in USB-C™ Travel Dock",
      id: "#jcdp392-show",
      desc: "90W Built-in USB-C™ Travel Dock"      
    },
    {
      value: "jcd392",
      label: "JCD392 - 4K60 Elite USB-C® 10Gbps Travel Dock",
      id: "#jcd392-show",
      desc: "4K60 Elite USB-C® 10Gbps Travel Dock"      
    },
    {
      value: "jcd398",
      label: "JCD398 - USB-C® Dual 4K HDMI™ 10Gbps Mini Dock",
      id: "#jcd398-show",
      desc: "USB-C® Dual 4K HDMI™ 10Gbps Mini Dock"      
    },
    {
      value: "jcd403",
      label: "JCD403 - USB4® 8K Multi-Port Hub",
      id: "#jcd403-show",
      desc: "USB4® 8K Multi-Port Hub"      
    },
    {
      value: "jce131",
      label: "JCE131 - USB-C™ Gigabit Ethernet Adapter",
      id: "#jce131-show",
      desc: "USB-C™ Gigabit Ethernet Adapter"      
    },
    {
      value: "jce131w",
      label: "JCE131W - USB-C® Gigabit Ethernet Adapter",
      id: "#jce131w-show",
      desc: "USB-C® Gigabit Ethernet Adapter"      
    },
    {
      value: "jch341e",
      label: "JCH341EW/ER/EC - Eco-Friendly USB-C® to 4-Port Type-A Gen 2 Hub",
      id: "#jch341e-show",
      desc: "Eco-Friendly USB-C® to 4-Port Type-A Gen 2 Hub"      
    },
    {
      value: "jch342e",
      label: "JCH342EW/ER/EC - Eco-Friendly USB-C® to 4-Port Type-C & Type-A Gen 2 Hub",
      id: "#jch342e-show",
      desc: "Eco-Friendly USB-C® to 4-Port Type-C & Type-A Gen 2 Hub"      
    },
    {
      value: "jch345e",
      label: "JCH345EW/ER/EC - Eco-Friendly USB-C® to 4-Port Type-C Gen 2 Hub",
      id: "#jch345e-show",
      desc: "Eco-Friendly USB-C® to 4-Port Type-C Gen 2 Hub"      
    },
    {
      value: "jch346",
      label: "JCH346 - USB-C™ 4-Port Hub with Power Delivery",
      id: "#jch346-show",
      desc: "USB-C™ 4-Port Hub with Power Delivery"      
    },
    {
      value: "jch377",
      label: "JCH377 - USB-C™ 7- Port Hub",
      id: "#jch377-show",
      desc: "USB-C™ 7- Port Hub"      
    },
    {
      value: "jch422",
      label: "JCH422 - Wormhole Switch™ CrossLink USB-C® HUB",
      id: "#jch422-show",
      desc: "Wormhole Switch™ CrossLink USB-C® HUB"      
    },
    {
      value: "jch453",
      label: "JCH453 - USB4® 8K60 Slim Hub",
      id: "#jch453-show",
      desc: "USB4® 8K60 Slim Hub"      
    },
    {
      value: "jch462",
      label: "JCH462 - Wormhole Switch™ Display Sharing Hub",
      id: "#jch462-show",
      desc: "Wormhole Switch™ Display Sharing Hub"      
    },
    {
      value: "jch471",
      label: "JCH471 - USB-C® Multi-Adapter Gigabit Ethernet / USB™ 3.1 HUB",
      id: "#jch471-show",
      desc: "USB-C® Multi-Adapter Gigabit Ethernet / USB™ 3.1 HUB"      
    },
    {
      value: "jda112",
      label: "JDA112 (BXMDPVGA) - mini DisplayPort™ to VGA",
      id: "#jda112-show",
      desc: "mini DisplayPort™ to VGA"      
    },
    {
      value: "jda132",
      label: "JDA132 - mini DisplayPort™ to DVI Adapter",
      id: "#jda132-show",
      desc: "mini DisplayPort™ to DVI Adapter"      
    },
    {
      value: "jda134",
      label: "JDA134 - DisplayPort™ to DVI Adapter",
      id: "#jda134-show",
      desc: "DisplayPort™ to DVI Adapter"      
    },
    {
      value: "jda152",
      label: "JDA152 - mini DisplayPort™ to HDMI™ Adapter",
      id: "#jda152-show",
      desc: "mini DisplayPort™ to HDMI™ Adapter"      
    },
    {
      value: "jda154",
      label: "JDA154 - DisplayPort™ to HDMI™ Adapter",
      id: "#jda154-show",
      desc: "DisplayPort™ to HDMI™ Adapter"      
    },
    {
      value: "jda158",
      label: "JDA158 - DisplayPort™ to 4K HDMI™ Active Adapter",
      id: "#jda158-show",
      desc: "DisplayPort™ to 4K HDMI™ Active Adapter"      
    },
    {
      value: "jda159",
      label: "JDA159 - mini DisplayPort™ to 4K HDMI™ Adapter",
      id: "#jda159-show",
      desc: "mini DisplayPort™ to 4K HDMI™ Adapter"      
    },
    {
      value: "jda173",
      label: "JDA173 - mini DisplayPort™ to 4K DisplayPort™/4K HDMI™/DVI Adapter",
      id: "#jda173-show",
      desc: "mini DisplayPort™ to 4K DisplayPort™/4K HDMI™/DVI"      
    },
    {
      value: "jda213",
      label: "JDA213 (BX4250) - HDMI™ to VGA Adapter",
      id: "#jda213-show",
      desc: "HDMI™ to VGA Adapter"      
    },
    {
      value: "jda214",
      label: "JDA214 - VGA to HDMI™ Video Audio Adapter",
      id: "#jda214-show",
      desc: "VGA to HDMI™ Video Audio Adapter"      
    },
    {
      value: "jee251",
      label: "JEE251 - 2.5 Inch SATA to USB™ 3.0 External Hard Drive Enclosure",
      id: "#jee251-show",
      desc: "2.5 Inch SATA to USB™ 3.0 External Hard Driver Enclosure"      
    },
    {
      value: "jee351",
      label: "JEE351 - 3.5 Inch SATA to USB™ 3.0 External Hard Drive Enclosure",
      id: "#jee351-show",
      desc: "3.5 Inch SATA to USB™ 3.0 External Hard Drive Enclosure"      
    },
    {
      value: "jcd543",
      label: "JCD543 - USB-C™ Triple Display Docking Station",
      id: "#jcd543-show",
      desc: "USB-C™ Triple Display Docking Station"      
    },
    {
      value: "jcd543p",
      label: "JCD543P - USB-C™ Triple Display Docking Station with 100W PD Adapter",
      id: "#jcd543p-show",
      desc: "USB-C™ Triple Display Docking Station with 100W PD Adapter"      
    },
    {
      value: "jcd542",
      label: "JCD542 - USB-C® Dual HDMI™ Docking Station",
      id: "#jcd542-show",
      desc: "USB-C® Dual HDMI™ Docking Station"
    },
    {
      value: "jcd3191",
      label: "JCD3191 - 4K60 Elite USB-C® Travel Adapter",
      id: "#jcd3191-show",
      desc: "4K60 Elite USB-C® Travel Adapter"
    },
    {
      value: "jcd3198",
      label: "JCD3198 - Type-C Dock Dual 4K HDMI™",
      id: "#jcd3198-show",
      desc: "Type-C Dock Dual 4K HDMI™"
    },
    {
      value: "jcd3199",
      label: "JCD3199 - USB-C® Dock Dual 4K HDMI™",
      id: "#jcd3199-show",
      desc: "USB-C® Dock Dual 4K HDMI™"
    },
    {
      value: "jcds335",
      label: "JCDS335 - USB-C® 4K Speakerphone Dock",
      id: "#jcds335-show",
      desc: "USB-C® 4K Speakerphone Dock"
    },
    {
      value: "jcds337",
      label: "JCDS337 - USB-C® Dual 4K Speakerphone Dock Pro",
      id: "#jcds337-show",
      desc: "USB-C® Dual 4K Speakerphone Dock Pro"
    },
    {
      value: "jpb26465",
      label: "JPB26465 - 26800mAh PD 65W 4-Port Power Bank",
      id: "#jpb26465-show",
      desc: "26800mAh PD 65W 4-Port Power Bank"
    },
    {
      value: "jpb5220",
      label: "JPB5220 - USB-C® Pocket Power Bank",
      id: "#jpb5220-show",
      desc: "USB-C® Pocket Power Bank"
    },
    {
      value: "jtsa101",
      label: "JTSA101 - Ergonomic Monitor Mount",
      id: "#jtsa101-show",
      desc: "Ergonomic Monitor Mount"
    },
    {
      value: "jtsa102",
      label: "JTSA102 - Ergonomic Dual Monitor Mount",
      id: "#jtsa102-show",
      desc: "Ergonomic Dual Monitor Mount"
    },
    {
      value: "jtsa301",
      label: "JTSA301 - Ergonomic Monitor Mount with Dock",
      id: "#jtsa301-show",
      desc: "Ergonomic Monitor Mount with Dock"
    },
    {
      value: "jtsa302",
      label: "JTSA302 - Ergonomic Dual-Monitor Mount with Docking Station",
      id: "#jtsa302-show",
      desc: "Ergonomic Dual-Monitor Mount with Docking Station"
    },
    {
      value: "jua190",
      label: "JUA190 (BX1VGA) - USB™ VGA Display Adapter",
      id: "#jua190-show",
      desc: "USB™ VGA Display Adapter"
    },
    {
      value: "jua195",
      label: "JUA195 - USB™ to HDMI™ Display Adapter",
      id: "#jua195-show",
      desc: "USB™ to HDMI™ Display Adapter"
    },
    {
      value: "jua210",
      label: "JUA210 (BX2VGA) - USB™ 2.0 VGA Display Adapter",
      id: "#jua210-show",
      desc: "USB™ 2.0 VGA Display Adapter"
    },
    {
      value: "jua214",
      label: "JUA214 - USB™ 3.0 VGA Multi-Monitor Adapter",
      id: "#jua214-show",
      desc: "USB™ 3.0 VGA Multi-Monitor Adapter"
    },
    {
      value: "jua230",
      label: "JUA230 - USB™ 2.0 DVI Display Adapter",
      id: "#jua230-show",
      desc: "USB™ 2.0 DVI Display Adapter"
    },
    {
      value: "jua250",
      label: "JUA250 (BX2HDMI) - USB™ 2.0 HDMI™ Display Adapter",
      id: "#jua250-show",
      desc: "USB™ 2.0 HDMI™ Display Adapter"
    },
    {
      value: "jua254",
      label: "JUA254/JUA255 - USB™ to HDMI™ Multi-Monitor Adapter",
      id: "#jua254-show",
      desc: "USB™ to HDMI™ Multi-Monitor Adapter"
    },
    {
      value: "jua258",
      label: "JUA258 - USB™ to HDMI™ Multi-Monitor Adapter",
      id: "#jua258-show",
      desc: "USB™ to HDMI™ Multi-Monitor Adapter"
    },
    {
      value: "jua310",
      label: "JUA310 (BX3VGAB) - USB™ 3.0 VGA Display Adapter",
      id: "#jua310-show",
      desc: "USB™ 3.0 VGA Display Adapter"
    },
    {
      value: "jua311",
      label: "JUA311 - USB™ 3.0 to VGA Display Adapter",
      id: "#jua311-show",
      desc: "USB™ 3.0 to VGA Display Adapter"
    },
    {
      value: "jua315",
      label: "JUA315 - USB™ 3.0 VGA Slim Display Adapter",
      id: "#jua315-show",
      desc: "USB™ 3.0 VGA Slim Display Adapter"
    },
    {
      value: "jua330",
      label: "JUA330/JUA330U - USB™ 3.0 DVI Display Adapter",
      id: "#jua330-show",
      desc: "USB™ 3.0 DVI Display Adapter"
    },
    {
      value: "jua350",
      label: "JUA350 (BX3HDMI) - USB™ to HDMI™ Display Adapter",
      id: "#jua350-show",
      desc: "USB™ to HDMI™ Display Adapter"
    },
    {
      value: "jua354",
      label: "JUA354 - USB™ 3.0 to 4K HDMI™ Display Adapter",
      id: "#jua354-show",
      desc: "USB™ 3.0 to 4K HDMI™ Display Adapter"
    },
    {
      value: "jua355",
      label: "JUA355 - USB™ 3.0 to HDMI™ Slim Display Adapter",
      id: "#jua355-show",
      desc: "USB™ 3.0 to HDMI™ Slim Display Adapter"
    },
    {
      value: "jua360",
      label: "JUA360 - USB™ 3.0 to HDMI™ & VGA Multi-Monitor Adapter",
      id: "#jua360-show",
      desc: "USB™ 3.0 to HDMI™ & VGA Multi-Monitor Adapter"
    },
    {
      value: "jua365",
      label: "JUA365 - USB™ 3.0 to Dual HDMI™ Multi-Monitor Adapter",
      id: "#jua365-show",
      desc: "USB™ 2.0 HDMI™ Display Adapter"
    },
    {
      value: "jua370",
      label: "JUA370 - USB 3.0 Multi-Adapter VGA & Gigabit Ethernet",
      id: "#jua370-show",
      desc: "USB 3.0 Multi-Adapter VGA & Gigabit Ethernet"
    },
    {
      value: "jua375",
      label: "JUA375 - USB™ 3.0 Multi-Adapter",
      id: "#jua375-show",
      desc: "USB™ 3.0 Multi-Adapter"
    },
    {
      value: "juc100",
      label: "JUC100 - Wormhole Switch™ USB™ Transfer Cable",
      id: "#juc100-show",
      desc: "Wormhole Switch™ USB™ Transfer Cable"
    },
    {
      value: "juc400",
      label: "JUC400 (BX2WH) - Wormhole Switch™ USB™ Transfer Cable",
      id: "#juc400-show",
      desc: "Wormhole Switch™ USB™ Transfer Cable"
    },
    {
      value: "juc500",
      label: "JUC500 - USB™ 3.0 Transfer Cable",
      id: "#juc500-show",
      desc: "USB™ 3.0 Transfer Cable"
    },
    {
      value: "juc600",
      label: "JUC600 - Android™ Mirror",
      id: "#juc600-show",
      desc: "Android™ Mirror"
    },
    {
      value: "juc610",
      label: "JUC610 - Android™ Mirror",
      id: "#juc610-show",
      desc: "Android™ Mirror"
    },
    {
      value: "juc700",
      label: "JUC700 - USB™ 3.0 Wormhole Switch DSS - KVM Swap & File Transfer",
      id: "#juc700-show",
      desc: "USB™ 3.0 Wormhole Switch DSS - KVM Swap & File Transfer"
    },
    {
      value: "jud200",
      label: "JUD200 - Newport Station",
      id: "#jud200-show",
      desc: "Newport Station"
    },
    {
      value: "jud380",
      label: "JUD380/JUD323 - USB™ 3.0 Mini Dock",
      id: "#jud380-show",
      desc: "USB™ 3.0 Mini Dock"
    },
    {
      value: "jud480",
      label: "JUD480 - Boomerang Station Universal USB™ 3.0 Docking Station",
      id: "#jud480-show",
      desc: "Boomerang Station Universal USB™ 3.0 Docking Station"
    },
    {
      value: "jud481",
      label: "JUD481 - Boomerang Station - Universal USB™ 3.0 Docking Station",
      id: "#jud481-show",
      desc: "Boomerang Station - Universal USB™ 3.0 Docking Station"
    },
    {
      value: "jud530",
      label: "JUD530 - USB™ 3.0 Mini Ultra Station",
      id: "#jud530-show",
      desc: "USB™ 3.0 Mini Ultra Station"
    },
    {
      value: "jud500",
      label: "JUD500 - Ultra Station",
      id: "#jud500-show",
      desc: "Ultra Station"
    },
    {
      value: "jud531",
      label: "JUD531 - Mini Ultra Station",
      id: "#jud531-show",
      desc: "Mini Ultra Station"
    },
    {
      value: "jud650",
      label: "JUD650 - Android™ Dock Phone / Tablet Workstation",
      id: "#jud650-show",
      desc: "Android™ Dock Phone / Tablet Workstation"
    },
    {
      value: "jue120",
      label: "JUE120 - USB™ 2.0 Ethernet Adapter",
      id: "#jue120-show",
      desc: "USB™ 2.0 Ethernet Adapter"
    },
    {
      value: "jue125",
      label: "JUE125 - USB™ 2.0 Ethernet Adapter",
      id: "#jue125-show",
      desc: "USB™ 2.0 Ethernet Adapter"
    },
    {
      value: "jue130",
      label: "JUE130 (BX3GIG) - USB™ 3.0 Gigabit Ethernet Adapter",
      id: "#jue130-show",
      desc: "USB™ 3.0 Gigabit Ethernet Adapter"
    },
    {
      value: "jue230",
      label: "JUE230 - Dual USB™ 3.0 to Gigabit Ethernet Sharing Adapter",
      id: "#jue230-show",
      desc: "Dual USB™ 3.0 to Gigabit Ethernet Sharing Adapter"
    },
    {
      value: "jue301",
      label: "JUE301 - Wireless 11N USB™ Mini Adapter",
      id: "#jue301-show",
      desc: "Wireless 11N USB™ Mini Adapter"
    },
    {
      value: "jue302",
      label: "JUE302 - Wireless N300 Dual Band USB™ Adapter",
      id: "#jue302-show",
      desc: "Wireless N300 Dual Band USB Adapter"
    },
    {
      value: "jue303",
      label: "JUE303 - Wireless AC600 Dual Band USB™ 2.0 Adapter",
      id: "#jue303-show",
      desc: "Wireless AC600 Dual Band USB™ 2.0 Adapter"
    },
    {
      value: "jue304",
      label: "JUE304 - Wireless AC1200 Dual Band USB™ 3.0 Adapter",
      id: "#jue304-show",
      desc: "Wireless AC1200 Dual Band USB™ 3.0 Adapter"
    },
    {
      value: "juh320v2",
      label: "JUH320V2 - USB™ 3.0 Wormhole Docking Station",
      id: "#juh320v2-show",
      desc: "USB™ 3.0 Wormhole Docking Station"
    },
    {
      value: "juh340",
      label: "JUH340 (BX34HUB) - USB™ 3.0 4-Port Mini Hub",
      id: "#juh340-show",
      desc: "USB™ 3.0 4-Port Mini Hub"
    },
    {
      value: "juh345",
      label: "JUH345 - USB™ 3.0 4-Port Harmonica Hub",
      id: "#juh345-show",
      desc: "USB™ 3.0 4-Port Harmonica Hub"
    },
    {
      value: "juh377",
      label: "JUH377 - USB™ 3.0 7-Port HUB",
      id: "#juh377-show",
      desc: "USB™ 3.0 7-Port HUB"
    },
    {
      value: "juh410",
      label: "JUH410 - USB™ 3.0 VGA & 3-Port HUB",
      id: "#juh410-show",
      desc: "USB™ 3.0 VGA & 3-Port HUB"
    },
    {
      value: "juh450",
      label: "JUH450 - USB™ 3.0 Multi-Adapter",
      id: "#juh450-show",
      desc: "USB™ 3.0 Multi-Adapter"
    },
    {
      value: "juh470",
      label: "JUH470 - USB™ 3.0 Multi-Adapter Gigabit Ethernet / 3-Port USB™ 3.0 HUB",
      id: "#juh470-show",
      desc: "USB™ 3.0 Multi-Adapter Gigabit Ethernet / 3-Port USB™ 3.0 HUB"
    },
    {
      value: "juh660",
      label: "JUH660 - Android™ AOA / OTG HUB",
      id: "#juh660-show",
      desc: "Android™ AOA / OTG HUB"
    },
    {
      value: "jut325",
      label: "JUT325 - Monitor Stand With 3-Port USB™ 3.0 HUB",
      id: "#jut325-show",
      desc: "Monitor Stand With 3-Port USB™ 3.0 HUB"
    },
    {
      value: "jva01",
      label: "JVA01 - Video Capture USB™ Hub",
      id: "#jva01-show",
      desc: "Video Capture USB™ Hub"
    },
    {
      value: "jva02",
      label: "JVA02 - Live Capture Adapter HDMI™ to USB-C™ with Power Delivery",
      id: "#jva02-show",
      desc: "Live Capture Adapter HDMI™ to USB-C™ with Power Delivery"
    },
    {
      value: "jva04",
      label: "JVA04 - Game Capture Station",
      id: "#jva04-show",
      desc: "Game Capture Station"
    },
    {
      value: "jva06",
      label: "JVA06 - Dual HDMI™ Video Capture",
      id: "#jva06-show",
      desc: "Dual HDMI™ Video Capture"
    },
    {
      value: "jva11",
      label: "JVA11 - 4K HDMI™ Capture Adapter",
      id: "#jva11-show",
      desc: "4K HDMI™ Capture Adapter"
    },
    {
      value: "jva14",
      label: "JVA14 - 4K Game Capture Station",
      id: "#jva14-show",
      desc: "4K Game Capture Station"
    },
    {
      value: "jvaw50",
      label: "JVAW50 - Wireless Display HDMI™ & USB™ Extender",
      id: "#jvaw50-show",
      desc: "Wireless Display HDMI™ & USB™ Extender"
    },
    {
      value: "jvaw53",
      label: "JVAW52 - Wireless Display HDMI™ Extender",
      id: "#jvaw53-show",
      desc: "Wireless Display HDMI™ Extender"
    },
    {
      value: "jvaw53",
      label: "JVAW53 - Wireless Display HDMI™ Extender",
      id: "#jvaw53-show",
      desc: "Wireless Display HDMI™ Extender"
    },
    {
      value: "jvaw54",
      label: "JVAW54 - ScreenCast Wireless Display Adapter",
      id: "#jvaw56-show",
      desc: "ScreenCast Wireless Display Adapter"
    },
    {
      value: "jvaw56",
      label: "JVAW56 - ScreenCast Wireless Display Adapter",
      id: "#jvaw56-show",
      desc: "ScreenCast Wireless Display Adapter"
    },
    {
      value: "jvaw62",
      label: "JVAW62 - ScreenCast USB-C® Wireless Display HDMI™ Extender",
      id: "#jvaw62-show",
      desc: "ScreenCast USB-C® Wireless Display HDMI™ Extender"
    },
    {
      value: "jvaw75",
      label: "JVAW75 - ScreenCast 4K Wireless Display HDMI™ Extender",
      id: "#jvaw75-show",
      desc: "ScreenCast 4K Wireless Display HDMI™ Extender"
    },
    {
      value: "jvaw76",
      label: "JVAW76 - ScreenCast 4K Wireless Display Adapter",
      id: "#jvaw76-show",
      desc: "ScreenCast 4K Wireless Display Adapter"
    },
    {
      value: "jvw120",
      label: "JVW120 - Wireless Extender For USB™ Cameras / Microphones / Speakers",
      id: "#jvw120-show",
      desc: "Wireless Extender For USB™ Cameras / Microphones / Speakers"
    },
    {
      value: "jvcu100",
      label: "JVCU100 - USB™ HD Webcam with 360° Rotation (Model:JVCU100)",
      id: "#jvcu100-show",
      desc: "USB™ HD Webcam with 360° Rotation (Model:JVCU100)"
    },
    {
      value: "jvcu360",
      label: "JVCU360 - 360° All Around Webcam (Model:JVCU360)",
      id: "#jvcu360-show",
      desc: "360° All Around Webcam (Model:JVCU360)"
    },
    {
      value: "jvu250",
      label: "JVU250 - HD Webcam with Auto & Manual Focus Switch",
      id: "#jvu250-show",
      desc: "HD Webcam with Auto & Manual Focus Switch"
    },
    {
      value: "jvu368",
      label: "JVU368 - 360° AI-Powered Webcam with Speakerphone",
      id: "#jvu368-show",
      desc: "360° AI-Powered Webcam with Speakerphone"
    },
    {
      value: "jvu430",
      label: "JVU430 - USB™ 4K ULTRA HD Webcam",
      id: "#jvu430-show",
      desc: "USB™ 4K ULTRA HD Webcam"
    },
    {
      value: "jvcu435",
      label: "JVCU435 - USB™ 4K ULTRA HD Webcam with 5x Digital Zoom Remote Control (Model:JVCU435)",
      id: "#jvcu435-show",
      desc: "USB™ 4K ULTRA HD Webcam with 5x Digital Zoom Remote Control (Model:JVCU435)"
    }
  ];
  
  $( "#downloads" ).autocomplete ({
    minLength: 2,
    source: function(request, response) {
        var results = $.ui.autocomplete.filter(downloads, request.term);
        response(results.slice(0, 15));
    },
    response: function(event, ui) {
      if (!ui.content.length) {
        var noResult = {value: "", label: "<b>No Results Found</b>"};
        ui.content.push(noResult);
      }
      else {
        $("#message").empty();
      }
    },
    select: function( event, ui ) {
      $( "#downloads-label" ).val( ui.item.label );
      $( "#downloads-id" ).val( ui.item.value );
      $( "#downloads-desc" ).html( ui.item.desc );
      $( "#downloads-id" ).append("<a href='" + ui.item.id + "'</a>");
      window.location.href = ui.item.id;
      return false;
    }
  })
  .autocomplete( "instance" )._renderItem = function( ul, item ) {
    let txtsearch = String(item.label).replace(new RegExp(this.term, "gi"),"<b>$&</b>");
    return $( "<li>" )
     .append( "<div>" + txtsearch + "</div>" )
     .appendTo( ul );
  };
  });

  // This controls the category menu selections and pagination
$(document).on('click', '.cat-click', function(e){
  var $type = $(this).data("cat-select");
  if($type == "show-all"){
    $('.cat-container').fadeOut(0);
    $('.cat-container').fadeIn(1000);
    $('.hide-cat').hide();
  }
  else {
    $('.cat-container').hide();
    $('#' + $type + ".cat-container").fadeIn(1000);
  }
})

  // This controls the main menu category choice selections
/*var items_menu = $(".cat-main-menu-wrapper .cat-main-menu-results");
    var numItems0 = items_menu.length;
    var perPage0 = 10;

    items_menu.slice(perPage0).hide()
    $(function() {
    $('.pagination-categories-main-menu').pagination({
        pages: 2,
        cssStyle: 'light-theme',
        prevText: "Prev",
        nextText: "Next",
        onPageClick: function (pageNumber) {
            var showFrom = perPage0 * (pageNumber - 1);
            var showTo = showFrom + perPage0;
            items_menu.hide().slice(showFrom, showTo).show();
        }
    })
    });*/

  // This controls the category menu pagination for the docking stations category menu
var items_docks = $(".cat-wrapper-docks .cat-results-docks");
    var numItems1 = items_docks.length;
    var perPage1 = 10;

    items_docks.slice(perPage1).hide();

    $(function() {
    $('.pagination-categories-docks').pagination({
        pages: 3,
        cssStyle: 'light-theme',
        prevText: "Prev",
        nextText: "Next",
        onPageClick: function (pageNumber) {
            var showFrom = perPage1 * (pageNumber - 1);
            var showTo = showFrom + perPage1;
            items_docks.hide().slice(showFrom, showTo).show();
        }
    })
    });

  // This controls the category menu pagination for the hubs category menu
var items_hubs = $(".cat-wrapper-hubs .cat-results-hubs");
    var numItems2 = items_hubs.length;
    var perPage2 = 10;

    items_hubs.slice(perPage2).hide();

    $(function() {
    $('.pagination-categories-hubs').pagination({
        pages: 3,
        cssStyle: 'light-theme',
        prevText: "Prev",
        nextText: "Next",
        onPageClick: function (pageNumber) {
            var showFrom = perPage2 * (pageNumber - 1);
            var showTo = showFrom + perPage2;
            items_hubs.hide().slice(showFrom, showTo).show();
        }
    })
    });

// This controls the category menu pagination for the networking category menu
var networking = $(".cat-wrapper-networking .cat-results-networking");
    var numItems3 = networking.length;
    var perPage3 = 10;

    networking.slice(perPage3).hide();

    $(function() {
    $('.pagination-categories-networking').pagination({
        pages: 2,
        cssStyle: 'light-theme',
        prevText: "Prev",
        nextText: "Next",
        onPageClick: function (pageNumber) {
            var showFrom = perPage3 * (pageNumber - 1);
            var showTo = showFrom + perPage3;
            networking.hide().slice(showFrom, showTo).show();
        }
    })
    });

// This controls the category menu pagination for the webcams category menu
var webcams = $(".cat-wrapper-webcams .cat-results-webcams");
    var numItems4 = webcams.length;
    var perPage4 = 10;

    webcams.slice(perPage4).hide();

    $(function() {
    $('.pagination-categories-webcams').pagination({
        pages: 1,
        cssStyle: 'light-theme',
        prevText: "Prev",
        nextText: "Next",
        onPageClick: function (pageNumber) {
            var showFrom = perPage4 * (pageNumber - 1);
            var showTo = showFrom + perPage4;
            webcams.hide().slice(showFrom, showTo).show();
        }
    })
    });

// This controls the category menu pagination for the enterprise category menu
var enterprise = $(".cat-wrapper-enterprise .cat-results-enterprise");
    var numItems5 = enterprise.length;
    var perPage5 = 10;

    enterprise.slice(perPage5).hide();

    $(function() {
    $('.pagination-categories-enterprise').pagination({
        pages: 1,
        cssStyle: 'light-theme',
        prevText: "Prev",
        nextText: "Next",
        onPageClick: function (pageNumber) {
            var showFrom = perPage5 * (pageNumber - 1);
            var showTo = showFrom + perPage5;
            enterprise.hide().slice(showFrom, showTo).show();
        }
    })
    });

// This controls the category menu pagination for the video capture category menu
var capture = $(".cat-wrapper-capture .cat-results-capture");
    var numItems6 = capture.length;
    var perPage6 = 10;

    capture.slice(perPage6).hide();

    $(function() {
    $('.pagination-categories-capture').pagination({
        pages: 1,
        cssStyle: 'light-theme',
        prevText: "Prev",
        nextText: "Next",
        onPageClick: function (pageNumber) {
            var showFrom = perPage6 * (pageNumber - 1);
            var showTo = showFrom + perPage6;
            capture.hide().slice(showFrom, showTo).show();
        }
    })
    });

// This controls the category menu pagination for the android category menu
var android = $(".cat-wrapper-android .cat-results-android");
    var numItems7 = android.length;
    var perPage7 = 10;

    android.slice(perPage7).hide();

    $(function() {
    $('.pagination-categories-android').pagination({
        pages: 1,
        cssStyle: 'light-theme',
        prevText: "Prev",
        nextText: "Next",
        onPageClick: function (pageNumber) {
            var showFrom = perPage7 * (pageNumber - 1);
            var showTo = showFrom + perPage7;
            android.hide().slice(showFrom, showTo).show();
        }
    })
    });

// This controls the category menu pagination for the monitor stands category menu
var stands = $(".cat-wrapper-stands .cat-results-stands");
    var numItems8 = stands.length;
    var perPage8 = 10;

    stands.slice(perPage8).hide();

    $(function() {
    $('.pagination-categories-stands').pagination({
        pages: 1,
        cssStyle: 'light-theme',
        prevText: "Prev",
        nextText: "Next",
        onPageClick: function (pageNumber) {
            var showFrom = perPage8 * (pageNumber - 1);
            var showTo = showFrom + perPage8;
            stands.hide().slice(showFrom, showTo).show();
        }
    })
    });

// This controls the category menu pagination for the display adapters category menu
var displayadapters = $(".cat-wrapper-displayadapters .cat-results-displayadapters");
    var numItems9 = displayadapters.length;
    var perPage9 = 10;

    displayadapters.slice(perPage9).hide();

    $(function() {
    $('.pagination-categories-displayadapters').pagination({
        pages: 4,
        cssStyle: 'light-theme',
        prevText: "Prev",
        nextText: "Next",
        onPageClick: function (pageNumber) {
            var showFrom = perPage9 * (pageNumber - 1);
            var showTo = showFrom + perPage9;
            displayadapters.hide().slice(showFrom, showTo).show();
        }
    })
    });

// This controls the category menu pagination for the wormhole category menu
var wormhole = $(".cat-wrapper-wormhole .cat-results-wormhole");
    var numItems10 = wormhole.length;
    var perPage10 = 10;

    wormhole.slice(perPage10).hide();

    $(function() {
    $('.pagination-categories-wormhole').pagination({
        pages: 1,
        cssStyle: 'light-theme',
        prevText: "Prev",
        nextText: "Next",
        onPageClick: function (pageNumber) {
            var showFrom = perPage10 * (pageNumber - 1);
            var showTo = showFrom + perPage10;
            wormhole.hide().slice(showFrom, showTo).show();
        }
    })
    });

// This controls the category menu pagination for the harddrive category menu
var harddrive = $(".cat-wrapper-harddrive .cat-results-harddrive");
    var numItems10 = harddrive.length;
    var perPage11 = 10;

    harddrive.slice(perPage11).hide();

    $(function() {
    $('.pagination-categories-harddrive').pagination({
        pages: 1,
        cssStyle: 'light-theme',
        prevText: "Prev",
        nextText: "Next",
        onPageClick: function (pageNumber) {
            var showFrom = perPage11 * (pageNumber - 1);
            var showTo = showFrom + perPage11;
            harddrive.hide().slice(showFrom, showTo).show();
        }
    })
    });

// This controls the category menu pagination for the wireless displays category menu
var widi = $(".cat-wrapper-wireless-displays .cat-results-widi");
    var numItems12 = widi.length;
    var perPage12 = 10;

    widi.slice(perPage12).hide();

    $(function() {
    $('.pagination-categories-wireless-displays').pagination({
        pages: 1,
        cssStyle: 'light-theme',
        prevText: "Prev",
        nextText: "Next",
        onPageClick: function (pageNumber) {
            var showFrom = perPage12 * (pageNumber - 1);
            var showTo = showFrom + perPage12;
            widi.hide().slice(showFrom, showTo).show();
        }
    })
    });

// operating system menu button toggle   
$(document).ready(function(){
	
  if ($('.js-msgbox .important_msg-flex-buttons button.button_os-select').length == 6)
    $('.js-msgbox .important_msg-flex-buttons button').addClass('tabs7');
  
	$('.js-msgbox button.button_os-select').click(function(){
		var button_os = $(this).attr('os-select');

		$('.js-msgbox button.button_os-select').removeClass('button-os-current');
		$('.js-msgbox .text-content').removeClass('button-os-current');

		//$(this).addClass('docking_stations-current');
		$("#" + button_os).addClass('button-os-current');
        $('.js-msgbox button[os-select=' + button_os + ']').addClass('button-os-current');
        $('.js-msgbox div[os-select=' + button_os + ']').addClass('button-os-current');
	})
})